var _jsxFileName = "/var/home/clovis/Documents/Mangane/app/soapbox/features/compose/components/upload-progress.tsx";
import React from 'react';
import UploadProgress from 'soapbox/components/upload-progress';
import { useAppSelector } from 'soapbox/hooks';

/** File upload progress bar for post composer. */
const ComposeUploadProgress = () => {
  const active = useAppSelector(state => state.compose.is_uploading);
  const progress = useAppSelector(state => state.compose.progress);
  if (!active) {
    return null;
  }
  return /*#__PURE__*/React.createElement(UploadProgress, {
    progress: progress,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 16,
      columnNumber: 5
    }
  });
};
export default ComposeUploadProgress;